export const isNonHeaderCsvError = (m: string): boolean =>
  m.startsWith("CSVファイルを読み取れませんでした") ||
  m.startsWith("CSVファイルのアップロードに失敗しました");
